import { FC, ReactNode } from "react"
import styled from "styled-components"

import {
  FormInput,
  InnerLabel,
  InputWrapper,
} from "../styles/FormElementStyles"

const StripeInputWrapper = styled(InputWrapper)`
  padding-top: 13px;

  & > .StripeElement::placeholder {
    opacity: 1;
    color: ${(props) => props.theme.input.placeholder};
  }
`

interface Props {
  label?: string | JSX.Element
  id?: string
  error?: any
  errorFeedback?: string | JSX.Element
  showLabel?: boolean
  children?: ReactNode
}

const StripeInput: FC<Props> = ({
  error,
  label,
  id,
  children,
  showLabel = true,
}) => (
  <FormInput>
    <StripeInputWrapper $error={error}>
      <InnerLabel htmlFor={id} $showLabel={showLabel}>
        {label}
      </InnerLabel>
      {children}
    </StripeInputWrapper>
  </FormInput>
)

export default StripeInput
